export default __webpack_public_path__ + "static/media/clouds-icon-citron.e3c5580a.svg";